
let inject = [
    '$scope',
    'PaymentCartService',
    '$state',
    '$rootScope',
    'SharedService',
    '$timeout',
    'ngAuthSettings',
    'SessionService',
    'NgTableParams',
    '$uibModal',
    '$window',
  ];
  class PaymentCartController {
    constructor($scope,
      PaymentCartService,
      $state,
      $rootScope,
      SharedService,
      $timeout,
      ngAuthSettings,
      SessionService,
      NgTableParams,
      $uibModal,
      $window) {
  
      this.$state = $state;
      this.SessionService = SessionService;
      this.ngAuthSettings = ngAuthSettings;
      this.NgTableParams = NgTableParams;
      this.$scope = $scope;
      this.$timeout = $timeout;
      this.$rootScope = $rootScope;
      this.PaymentCartService = PaymentCartService;
      this.$uibModal = $uibModal;
      this.SharedService = SharedService;
      this.total = null;
      this.toDay = new Date();
      this.fecha = null;
      this.globals = null;
      this.concepType = 2;
      this.itemsCart = [];
      this.totalCartPay = null;
    }
  
    $onInit() {

      this.fecha = this.toDay.getFullYear() + "-" + (this.toDay.getMonth() +1) + "-" + this.toDay.getDate();
      this.globals = this.shCtrl.globals;

    }
      

   clear(){
      this.globals.currentUser.payCart = [];
      this.globals.currentUser.totalCartPay = null;
      this.SessionService.put('globals', this.globals);
    }

    removeItems(val){
      this.dataTemp = this.globals.currentUser.payCart[val.key].valor_pagar_hoy;
      this.globals.currentUser.payCart.splice(val.key,1);
      this.globals.currentUser.totalCartPay = (this.globals.currentUser.totalCartPay -this.dataTemp);
      angular.copy(this.globals.currentUser,this.globals.currentClient);
      this.SessionService.put('globals', this.globals);
    }

  
  }
  
  PaymentCartController.$inject = inject;
  
  export default PaymentCartController;
  
  


/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/payments-advances/payment-cart/payment-cart.controller.js
 **/